export default "__VITE_ASSET__XQYvwhGS__"